import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/popup_error.svg'


const _withScopeId = n => (_pushScopeId("data-v-7ae1372e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component popup" }
const _hoisted_2 = { class: "popup-box contents__box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = { class: "text-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "테이블을 추가하여 약제값을 입력하거나", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "TDM 추천을 이용하세요.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", null, "TDM " + _toDisplayString(_ctx.patientInfo.VNC.length) + "차 이후에 투여한 약제값이 없습니다.", 1),
        _hoisted_5,
        _hoisted_6
      ]),
      _createElementVNode("button", {
        class: "confirm-btn button__blue",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePopup()))
      }, "확인")
    ])
  ]))
}